var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.shouldShowNavBar)?_c('main-navbar'):_vm._e(),_c('div',{staticClass:"main-container"},[_c('router-view',{attrs:{"id":"router-view"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }